var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.875C13.2751 0.875 12.6875 1.46263 12.6875 2.1875V3.58124C7.93793 4.1735 4.1735 7.93793 3.58124 12.6875H2.1875C1.46263 12.6875 0.875 13.2751 0.875 14C0.875 14.7249 1.46263 15.3125 2.1875 15.3125H3.58124C4.1735 20.0621 7.93793 23.8265 12.6875 24.4188V25.8125C12.6875 26.5374 13.2751 27.125 14 27.125C14.7249 27.125 15.3125 26.5374 15.3125 25.8125V24.4188C20.0621 23.8265 23.8265 20.0621 24.4188 15.3125H25.8125C26.5374 15.3125 27.125 14.7249 27.125 14C27.125 13.2751 26.5374 12.6875 25.8125 12.6875H24.4188C23.8265 7.93793 20.0621 4.1735 15.3125 3.58124V2.1875C15.3125 1.46263 14.7249 0.875 14 0.875ZM14 21.875C9.65076 21.875 6.125 18.3492 6.125 14C6.125 9.65076 9.65076 6.125 14 6.125C18.3492 6.125 21.875 9.65076 21.875 14C21.875 18.3492 18.3492 21.875 14 21.875ZM14 17.9375C16.1746 17.9375 17.9375 16.1746 17.9375 14C17.9375 11.8254 16.1746 10.0625 14 10.0625C11.8254 10.0625 10.0625 11.8254 10.0625 14C10.0625 16.1746 11.8254 17.9375 14 17.9375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocator);
export default __webpack_public_path__ + "static/media/locator.a6470f226216be8be213bc50a33c0ce4.svg";
export { ForwardRef as ReactComponent };